import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';
import { Breadcrumb } from '../../breadcrumbs.types';
import { SVG } from 'components';
import { Dropdown, Text } from 'components/ui';
import { StyledMoreButton } from './more-button.styled';
import { Icons } from 'assets';

interface IProps {
  crumbs: Array<Breadcrumb>;
}

export const MoreButton: FC<IProps> = observer(({ crumbs }) => {
  return (
    <Dropdown.Root>
      <Dropdown.Trigger asChild>
        <StyledMoreButton>
          <SVG
            src={Icons.Dots}
            props={{
              cursor: 'inherit',
              deg: 90,
            }}
          />
        </StyledMoreButton>
      </Dropdown.Trigger>

      <Dropdown.Portal>
        <Dropdown.Content
          align="start"
          style={{
            maxHeight: 300,
          }}
        >
          {crumbs.map((crumb, index) => (
            <Dropdown.Item asChild key={index}>
              <Link
                to={crumb.href}
                style={{
                  textDecoration: 'none',
                }}
              >
                <Text>{crumb.label}</Text>
              </Link>
            </Dropdown.Item>
          ))}
        </Dropdown.Content>
      </Dropdown.Portal>
    </Dropdown.Root>
  );
});
